import React from "react"
import PropTypes from "prop-types"
import { Link } from "gatsby"


const AreaList = ({areaCopy, areaName, areaList}) => {

  return (
    <div className="container">
      <h4>{areaCopy} {areaName}</h4>
      <div className="local">
        <ul>
          {
            areaList &&
            areaList.map((area, i) => {
              const href = area[`link`]
              const area_name = area[`area_name`]
              // Use standard anchor tags if external links are detected,
              // to avoid prefix.
              if (href.indexOf("https:") > -1) {
                return (
                  <li key={`areas-nearby-${i}`}>
                    <a href={`${href}`}>{area_name}</a>
                  </li>
                )
              } else {
                return (
                  <li key={`areas-nearby-${i}`}>
                    <Link to={`${href}`}>{area_name}</Link>
                  </li>
                )
              }
            })
          }
        </ul>
      </div>
    </div>
  )
}

AreaList.propTypes = {
  areaCopy: PropTypes.string.isRequired,
  areaName: PropTypes.string.isRequired,
  lang: PropTypes.string,
  areaList: PropTypes.arrayOf(
    PropTypes.shape({
      link_en: PropTypes.string,
      link_es: PropTypes.string,
      area_name: PropTypes.string,
      area_name_es: PropTypes.string
    })
  ).isRequired
}

AreaList.defaultProps = {
  lang: "en"
}

export default AreaList
